const isChangedData = (cachedData, data) => cachedData !== data;
export const shouldRefresh = (cachedData, data) => data && (!cachedData || isChangedData(cachedData, data));
